
define('ldsh!modules/form_editor/templates/editor_custom_range', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-form-group">\n  <div class="md__checkbox--wrapper">\n    <input\n      id="first-item"\n      type="checkbox"\n      class="md__checkbox--primary js-first"\n      ' +
((__t = ( firstOptionInvalid ? "checked": "" )) == null ? '' : __t) +
'\n    />\n    <label\n      for="first-item"\n      data-i18n="formEditor.dropDownFirstValueInvalid"\n    ></label>\n  </div>\n</div>\n\n<div class="flex align-center gap12 clearfix">\n  <div class="flex flex-column align-flex-start gap8">\n    <label\n      class="control-label"\n      data-i18n="[text]formEditor.rangeStart"\n    >Inicio</label>\n    <input type="text" class="form-control js-start" value="' +
((__t = ( start )) == null ? '' : __t) +
'">\n  </div>\n  <div class="flex flex-column align-flex-start gap8">\n    <label\n      class="control-label"\n      data-i18n="[text]formEditor.rangeEnd"\n    >Fin</label>\n    <input type="text" class="form-control js-end" value="' +
((__t = ( end )) == null ? '' : __t) +
'">\n  </div>\n</div>\n\n';
 if (showZeroFillCheck) { ;
__p += '\n<div class="ed-form-group mt12">\n  <div class="md__checkbox--wrapper">\n    <input\n      id="fill-zeroes"\n      type="checkbox"\n      class="md__checkbox--primary js-fill-zeroes"\n      ' +
((__t = ( fillWithZeroes ? "checked": "" )) == null ? '' : __t) +
'\n    />\n    <label\n      for="fill-zeroes"\n      data-i18n="formEditor.fillWithZero"\n    ></label>\n  </div>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

